// extracted by mini-css-extract-plugin
export default {"title":"tzy4Gg","defaultLayout":"NmQahy","cards":"vipNKb","listLayout":"Z6KKel","mobile":"DutUYb","mobileFontSize":"uOFQOW"};